import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RateInput.scss';
var RateInput = /*#__PURE__*/function (_Component) {
  function RateInput(props) {
    var _this;
    _classCallCheck(this, RateInput);
    _this = _callSuper(this, RateInput, [props]);
    var value = props.value || props.value === 0 ? props.value : '';
    _this.state = {
      value: value
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.onAnswerChange = props.onAnswerChange;
    return _this;
  }
  _inherits(RateInput, _Component);
  return _createClass(RateInput, [{
    key: "handleChange",
    value: function handleChange(event) {
      var allowDecimals = this.props.allowDecimals;
      var value = event.target.value;
      var re = /^[0-9\b]+(\.)?[0-9\b]?[0-9\b]?$/;
      var reWholeNumberOnly = /^[0-9]+$/;
      if (allowDecimals && (value === '' || re.test(value)) || !allowDecimals && (value === '' || reWholeNumberOnly.test(value))) {
        this.setState({
          value: value
        });
        this.onAnswerChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onBlur = _this$props.onBlur,
        onboardingQuestionnaire = _this$props.onboardingQuestionnaire,
        minOrMax = _this$props.minOrMax,
        children = _this$props.children,
        containerClass = _this$props.containerClass,
        inputClass = _this$props.inputClass,
        readOnly = _this$props.readOnly;
      var value = this.state.value;
      return /*#__PURE__*/React.createElement("div", {
        className: "rate-input-container ".concat(containerClass)
      }, /*#__PURE__*/React.createElement("div", null, minOrMax || ''), /*#__PURE__*/React.createElement("div", {
        className: "input-group budget-input d-flex align-items-center"
      }, children, /*#__PURE__*/React.createElement("input", {
        id: this.props.id,
        type: "number",
        className: "rate-input form-control ".concat(inputClass, " ").concat(onboardingQuestionnaire ? 'onboarding-input-edges' : ''),
        value: value,
        onChange: this.handleChange,
        onBlur: onBlur,
        placeholder: this.props.placeholder,
        readOnly: readOnly
      })));
    }
  }]);
}(Component);
RateInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  children: PropTypes.node,
  onboardingQuestionnaire: PropTypes.bool,
  minOrMax: PropTypes.string,
  containerClass: PropTypes.string,
  inputClass: PropTypes.string,
  allowDecimals: PropTypes.bool,
  readOnly: PropTypes.bool
};
RateInput.defaultProps = {
  value: '',
  placeholder: '',
  onBlur: function onBlur() {},
  children: /*#__PURE__*/React.createElement("span", {
    className: "input-group-addon"
  }, "$"),
  onboardingQuestionnaire: false,
  minOrMax: null,
  containerClass: '',
  inputClass: '',
  allowDecimals: true,
  readOnly: false
};
export default RateInput;